import { useMemo } from 'react';
import dayjs from 'dayjs';
import { getDefaultHoursPayOutPeriod } from '../../hours-pay-out-requests-overview/HoursPayOutRequestsOverview.const';

export const useQualityMonitorDateRanges = () => {
  const today = dayjs().format('YYYY-MM-DD');

  return useMemo(() => {
    const startOfLastMonth = dayjs(today).subtract(1, 'month').startOf('month');
    // Taken from the overview instead of restated here, so the tile's count and the overview it
    // links to can never be counted over different periods.
    const [startHoursPayOutRequests, endHoursPayOutRequests] =
      getDefaultHoursPayOutPeriod();

    return {
      startDateDayLimitViolations: startOfLastMonth,
      endDateDayLimitViolations: dayjs(today).add(1, 'month').endOf('month'),
      startDateAdditionalCompensations: startOfLastMonth,
      endDateAdditionalCompensations: dayjs(today).endOf('month'),
      startDateHoursPayOutRequests: dayjs(startHoursPayOutRequests),
      endDateHoursPayOutRequests: dayjs(endHoursPayOutRequests)
    };
  }, [today]);
};
